import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { LuChevronUp, LuChevronDown } from 'react-icons/lu';
import api from '../../services/api';
import ModalShell from '../ui/ModalShell';
import { etiquetaFranja, franjaDeVisita } from '../../utils/franjas';

// Cambiar el orden de las visitas de un técnico en un día (3-nov-2026), desde la Agenda de Trabajos.
// Antes solo estaba en Mapa → Agenda y no se encontraba. Las mismas franjas se reparten en el orden nuevo.
export default function CambiarOrdenSheet({ visitas, tecnicoNombre, onCerrar, onListo }) {
    const [lista, setLista] = useState(visitas);
    const [guardando, setGuardando] = useState(false);
    const franjas = visitas.map(o => franjaDeVisita(o));
    const mover = (i, d) => setLista(l => { const n = [...l]; [n[i], n[i + d]] = [n[i + d], n[i]]; return n; });
    const guardar = async () => {
        setGuardando(true);
        try {
            const r = await api.post('/mapa/reordenar', { ordenIds: lista.map(o => o.id) });
            toast.success(r.data?.cambiadas ? `Orden guardado. Le avisamos a ${tecnicoNombre}.` : 'Orden guardado');
            onListo && onListo();
        } catch (e) {
            toast.error(e?.response?.data?.mensaje || 'No se pudo guardar el orden');
        } finally {
            setGuardando(false);
        }
    };
    const btn = 'w-10 h-10 rounded-xl bg-chip text-secondary flex items-center justify-center active:scale-95 disabled:opacity-30';
    return (
        <ModalShell titulo="Cambiar orden" subtitulo={`Recorrido de ${tecnicoNombre}`} onCerrar={onCerrar} lateral
            pie={
                <div className="flex gap-2">
                    <button type="button" onClick={onCerrar} className="flex-1 h-12 rounded-xl bg-chip text-secondary text-label font-black active:scale-95">Cancelar</button>
                    <button type="button" onClick={guardar} disabled={guardando}
                        className="flex-[2] h-12 rounded-xl bg-[#C9341F] text-white text-body font-black active:scale-95 disabled:opacity-50">
                        {guardando ? 'Guardando…' : 'Guardar orden'}
                    </button>
                </div>
            }>
            <div className="space-y-2">
                <p className="text-caption text-muted px-1">Subí o bajá cada visita. Los horarios quedan en el mismo lugar y cada visita toma el de su posición.</p>
                {lista.map((o, i) => (
                    <div key={o.id} className="flex items-center gap-2 p-3 rounded-2xl bg-panel">
                        <span className="w-16 shrink-0 text-caption font-black text-ink">{franjas[i] ? etiquetaFranja(franjas[i]) : 'Sin hora'}</span>
                        <span className="flex-1 min-w-0">
                            <span className="block text-body font-black text-ink truncate">{o.lugar || o.clienteNombre || o.titulo}</span>
                            <span className="block text-caption text-muted truncate">{o.direccion || ''}</span>
                        </span>
                        <button type="button" onClick={() => mover(i, -1)} disabled={i === 0} aria-label="Subir" className={btn}><LuChevronUp size={18} /></button>
                        <button type="button" onClick={() => mover(i, 1)} disabled={i === lista.length - 1} aria-label="Bajar" className={btn}><LuChevronDown size={18} /></button>
                    </div>
                ))}
            </div>
        </ModalShell>
    );
}
